import tenantConfig from "../../../tenant.config";
import { Renew2022TnsOrderDataModel } from "../../controllers/campaign/renew2022/renew2022";
import { CampaignDataModel } from "./campaign";

// 256 random char
const code =
  "f5iSN2Rim7bkE6XYGF08oIGkbYtvK2fuInRLuxvvR6mgBDhQe7InbYsa0TtwxCCxgYAXB92Isiqnc9ndtHNZPGWprh58w4OnhcypzFa01UCQ6of5thxKQDR0koGrfKC6XiCZIVotLAxDzpMoDtZ6CkkquOaICMFbOAOggF48BoN0EZgklBblOWUP7fqjJDhGptqTngIXOx7EK0u4pgS8nisR95wW5o7KBlL2r5pAXcS3nFQBpln4CkCAloCGmdpf";
const expiry = new Date("October 31, 2022 23:59:59");

export const renew2022CampaignData: CampaignDataModel = {
  data: {
    code: code,
    expiry: expiry,
  },
  login: {
    title: `Renew 2022 - ${tenantConfig.entity_short_name}`,
    info: `If you received an email from ${tenantConfig.entity_short_name} for a specific event, please use that email address.`,
  },
  signup: {
    title: `Renew 2022 - ${tenantConfig.entity_short_name}`,
    info: `If you received an email from ${tenantConfig.entity_short_name} for a specific event, please use that email address.`,
  },
};

// campaign has expired + secondaries hardcoded value is removed.
// Thus, commented out hardcoded data and replaced with dummy value
export const renew2022TnsOrderData: Renew2022TnsOrderDataModel = {
  // Variables
  asset_id: "29bfd909-b20c-4600-998e-90ba4937818f",
  // listing_id: secondariesValue[0].listing_id,
  listing_id: "0",
  currency_symbol: "USD",
  // initial_price: secondariesValue[0].price_per_unit,
  initial_price: "0",
  original_unit: "5",
  // Constants
  order_type: "buy",
  outstanding_unit: "0",
  status: "closed",
};
